import { CmsMeta } from '../cmsMeta';
import SanitizedHtml from '../../SanitizedHtml/SanitizedHtml';

export const CmsHtml = ({ content }: { content: string }) => {
	return <SanitizedHtml html={content} className="content" />;
};

export const cmsMeta: CmsMeta = {
	description:
		'Free text: headings, paragraphs, lists and links. Sanitised on render, so scripts, iframes and event attributes are dropped whatever is passed.',
	example: ['CmsHtml', { content: '<h2>Alles für den Arbeitsplatz</h2><p>Von Büro und Lager bis zur Pause.</p>' }],
};
